var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.can('DEPARTMENT_CREATE'))?_c('base-crud-page-create',{attrs:{"title":_vm.$tc('menu.department', 1),"back-url":{ name: 'mainDepartments' }},scopedSlots:_vm._u([{key:"form",fn:function(){return [_c('the-form',{attrs:{"model":_vm.model},on:{"emit:submit":_vm.save}})]},proxy:true}],null,false,4132879617)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }